import { useCallback, useContext } from "react";
import { GlobalContext } from "../components/GlobalContext";

const getRandomDuration = () => {
  return 4 + Math.random() * 2;
};

const getRandomX = () => {
  const screenWidth = window.innerWidth;
  const thirdWidth = screenWidth / 3;
  return thirdWidth + Math.random() * thirdWidth;
};

export function useFloatingEmojis() {
  const context = useContext(GlobalContext);
  const showFloatingEmoji = useCallback(
    (emoji: string, name: string) => {
      const newEmoji = {
        id: Date.now(),
        emoji,
        name,
        startX: getRandomX(),
        duration: getRandomDuration(),
      };

      context.setEmojis((prev) => [...prev, newEmoji]);

      setTimeout(() => {
        context.setEmojis((prev) => prev.filter((e) => e.id !== newEmoji.id));
      }, newEmoji.duration * 1000);
    },
    [context]
  );

  return {
    emojis: context.emojis,
    showFloatingEmoji,
  };
}
